import React, { useEffect, useState } from "react";
import { adminApi } from "../../utils/adminApi";
import "./AdminServices.css";

export default function ServicesAdmin() {
  const [form, setForm] = useState({
    title: "",
    h1: "",
    description: "",
    types: "",
    issues: "",
  });

  const [services, setServices] = useState([]);

  // Quick add templates
  const serviceTemplates = [
    {
      title: "Washing Machine Repair Service",
      h1: "Washing Machine Repair Service",
      description: "Professional washing machine repair services with trained technicians",
      types: "Front Load Washing Machines, Top Load Washing Machines, Semi Automatic Machines",
      issues: "Not spinning, Water leakage, Drum issues, Power failure",
    },
    {
      title: "Refrigerator Repair Service",
      h1: "Refrigerator Repair Service",
      description: "Expert refrigerator and fridge repair services for all brands",
      types: "Single Door Fridge, Double Door Refrigerator, Side-by-Side Fridge, Mini Fridge",
      issues: "Cooling issues, Gas refilling, Compressor problems, Noise issues",
    },
    {
      title: "AC Repair Service",
      h1: "AC Repair Service",
      description: "Professional AC and air conditioner repair services for all types",
      types: "Split AC, Window AC, Inverter AC, Smart AC",
      issues: "Not cooling, Gas leakage, Compressor failure, Water leakage",
    },
  ];

  const loadTemplate = (template) => {
    setForm(template);
  };

  const fetchData = async () => {
    try {
      const res = await adminApi.get("/api/services");
      setServices(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAdd = async () => {
    if (!form.title) return alert("Title required");

    try {
      const res = await adminApi.post("/api/services", {
        ...form,
        types: form.types.split(",").map((t) => t.trim()).filter(Boolean),
        issues: form.issues.split(",").map((i) => i.trim()).filter(Boolean),
        link: "/service-page",
      });

      console.log("SUCCESS:", res.data);
      alert("Service added successfully");

      setForm({
        title: "",
        h1: "",
        description: "",
        types: "",
        issues: "",
      });

      fetchData();
    } catch (err) {
      console.error("POST ERROR:", err.response || err.message);
      alert("Add failed. Check console.");
    }
  };

  const handleDelete = async (id) => {
    await adminApi.delete(`/api/services/${id}`);
    fetchData();
  };

  return (
    <div className="admin-dashboard">
      <h1 className="admin-title">Service Management</h1>

      {/* QUICK ADD TEMPLATES */}
      <div className="admin-card">
        <h3>📋 Quick Add Templates</h3>
        <div className="template-buttons">
          {serviceTemplates.map((template, index) => (
            <button
              key={index}
              className="template-btn"
              onClick={() => loadTemplate(template)}
            >
              ➕ {template.title}
            </button>
          ))}
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-form">
          <input
            placeholder="Service Title"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />

          <input
            placeholder="H1 Heading"
            value={form.h1}
            onChange={(e) => setForm({ ...form, h1: e.target.value })}
          />

          <textarea
            placeholder="Description"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
          />

          <input
            placeholder="Types (comma)"
            value={form.types}
            onChange={(e) => setForm({ ...form, types: e.target.value })}
          />

          <input
            placeholder="Issues (comma)"
            value={form.issues}
            onChange={(e) => setForm({ ...form, issues: e.target.value })}
          />

          <button className="small-btn" onClick={handleAdd}>
            Add Service
          </button>
        </div>
      </div>

      <div className="admin-card">
        <h3>All Services</h3>

        <div className="admin-list">
          {services.map((service) => (
            <div key={service._id} className="admin-list-item">
              <div className="service-info">
                <strong>{service.title}</strong>
                <p>{service.h1}</p>
              </div>

              <div className="admin-actions">
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(service._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
